var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 56,
    viewBox: "0 0 70 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.622.162v26.6H16.23l-.31-2.588c-1.465 2.244-3.816 3.005-6.128 3.005C4.201 27.18 0 23.526 0 17.362c0-6.47 4.124-9.818 9.675-9.818 2.005 0 5.127 1.066 6.245 3.006V.16h4.702v.002zm-15.92 17.2c0 3.273 2.39 5.517 5.397 5.517 3.006 0 5.511-2.13 5.511-5.517 0-3.388-2.544-5.48-5.511-5.48s-5.396 2.092-5.396 5.48zM29.835 2.71c0 3.615-5.551 3.615-5.551 0 0-3.614 5.55-3.614 5.55 0zm-5.126 5.213v18.835h4.702V7.923H24.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.29 7.696c-2.39 0-4.318.952-6.245 2.816l-.307-2.55h-4.202L33.51 39.37c-1.118-1.94-4.24-3.005-6.244-3.005-5.552 0-9.676 3.348-9.676 9.818 0 6.469 4.202 9.817 9.791 9.817 2.314 0 4.664-.76 6.129-3.005l.309 2.587h4.394l-.014-38.41c0-2.853 1.966-5.251 4.857-5.251 2.89 0 4.587 2.17 4.587 5.023v9.817h4.703v-9.855c0-5.898-3.585-9.208-8.057-9.208v-.002zM27.688 51.7c-3.006 0-5.396-2.245-5.396-5.518 0-3.273 2.39-5.48 5.396-5.48s5.512 2.207 5.512 5.48c0 3.273-2.545 5.518-5.512 5.518z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.49 31.532c0 3.614-5.552 3.614-5.552 0 0-3.615 5.551-3.615 5.551 0zm-5.127 5.212v18.835h4.703V36.744h-4.703zM65.297 55.58v-9.817c0-2.853-1.58-5.023-4.587-5.023-3.006 0-4.857 2.397-4.857 5.252v9.589H51.19V36.783h4.202l.307 2.55c1.928-1.864 3.855-2.816 6.245-2.816 4.47 0 8.056 3.31 8.056 9.209v9.855h-4.703z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.1a75d3ec0bd114cdb5f1803e1d62ff57.svg";
export { ForwardRef as ReactComponent };